import ParentHeader from '../components/common/ParentHeader';
import SubscriptionsTab from '../components/pricing/SubscriptionsTab';
import { useCurrentUser } from '../hooks/useCurrentUser';
import { fontSize, fontWeight, textColor } from '@/theme';

export default function ParentPlans() {
  const userDetails = useCurrentUser() as any;
  const stateCode = userDetails?.state_code || '';
  const cityCode  = userDetails?.city_code  || '';

  return (
    <div className="min-h-screen bg-gray-50">
      <ParentHeader />
      <main className="max-w-full mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <div className="mb-8">
          <h1 className={`${fontSize['3xl']} ${fontWeight.bold} ${textColor.heading}`}>
            Plans
          </h1>
          <p className={`${textColor.muted} mt-1 text-sm`}>
            View available subscription plans in your area
          </p>
        </div>
        <SubscriptionsTab
          searchQuery=""
          onAddHandlerReady={() => {}}
          stateCodeOverride={stateCode}
          cityCodeOverride=''
        />
      </main>
    </div>
  );
}
